import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom'

import ClePipelineView from './ClePipelineView'
import cs from './cle_demo.scss'
import HitpickingWorkflow from './HitpickingWorkflow'
import PlatePageCle2025 from './PlatePage/PlatePageCle2025'
import WellPageCle2025 from './PlatePage/WellPageCle2025'

const Cle2025Demo = ({ useLocalAssets }: { useLocalAssets: boolean }) => {
  const match = useRouteMatch()

  return (
    <div className={cs.cleDemo}>
      <Switch>
        <Route
          exact
          path={match.path}
          render={() => <Redirect to={`${match.path}/pipeline`} />}
        />
        <Route
          exact
          path={`${match.path}/pipeline`}
          render={() => <ClePipelineView useLocalAssets={useLocalAssets} />}
        />
        <Route
          exact
          path={`${match.path}/decisions/hitpicking/:cellLineName`}
          render={({
            match: {
              params: { cellLineName },
            },
          }) => (
            <HitpickingWorkflow
              cellLineName={cellLineName}
              useLocalAssets={useLocalAssets}
            />
          )}
        />
        <Route
          exact
          path={`${match.path}/plate/:id`}
          render={({
            match: {
              params: { id },
            },
          }) => (
            <PlatePageCle2025 id={id} enableSelection={true} routePrefix={match.path} />
          )}
        />

        <Route
          exact
          path={`${match.path}/plate/:id/well/:pos`}
          render={({
            match: {
              params: { id, pos },
            },
          }) => (
            <WellPageCle2025
              plateID={id}
              pos={pos}
              enableLineage={true}
              routePrefix={match.path}
            />
          )}
        />
      </Switch>
    </div>
  )
}

export default Cle2025Demo
